var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0012 7.35107C9.45984 7.35107 8.2041 8.63427 8.2041 10.2149C8.2041 11.7931 9.45738 13.0788 11.0012 13.0788C12.5425 13.0788 13.7983 11.7956 13.7983 10.2149C13.7958 8.63679 12.5425 7.35107 11.0012 7.35107Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.44 1.92857C17.6369 2.86891 18.4618 3.5521 19.4023 3.5521C20.8354 3.5521 22 4.74454 22 6.21176V15.3403C22 16.8076 20.8354 18 19.4023 18H2.59765C1.16463 18 0 16.8076 0 15.3403V6.21176C0 4.74454 1.16463 3.5521 2.59765 3.5521C3.53822 3.5521 4.36307 2.86891 4.56004 1.92857C4.79396 0.811765 5.77392 0 6.88931 0H15.1107C16.2261 0 17.206 0.811765 17.44 1.92857ZM6.40425 10.2151C6.40425 12.8092 8.46514 14.9218 11.0012 14.9218C13.5349 14.9218 15.5982 12.8092 15.5982 10.2151C15.5982 7.62101 13.5349 5.5084 11.0012 5.5084C8.4676 5.5084 6.40425 7.62101 6.40425 10.2151Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraAvatar);
export default __webpack_public_path__ + "static/media/camera-avatar.8a5a88c9.svg";
export { ForwardRef as ReactComponent };